import LangkahPenetapanPredikatKinerja from 'app/KinerjaPage/pages/PelaksanaanV2/PenilaianKinerja/LangkahPenetapanPredikatKinerja'
import KinerjaLayout from 'app/KinerjaPage/components/KinerjaDemoLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const isKinerjaEnabled = toggle?.['kinerja-enabled'] || false
    const isKinerjaPelaksanaanEnabled =
      toggle?.['kinerja-pelaksanaan-enabled'] || false
    const isKinerjaDemoModeEnabled =
      toggle?.['kinerja-penilaian-demo-mode-enabled']

    if (
      !isKinerjaEnabled ||
      !isKinerjaPelaksanaanEnabled ||
      !isKinerjaDemoModeEnabled
    ) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }

    return { props: {} }
  },
})

export default function Page() {
  return <LangkahPenetapanPredikatKinerja npsn="demo" />
}

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
  className: 'text-default !max-w-full min-h-screen',
  forceResolution: true,
}
